import { arrayBuilderItemSubsequentPageTitleUI } from 'platform/forms-system/src/js/web-component-patterns';

import {
  conditionDateSchema,
  conditionDateUI,
  forceFieldBlurSchema,
  forceFieldBlurUI,
} from './conditionDateField';
import { createNewConditionName } from './utils';

/**
 * Builds the "When did your condition start?" page.
 *
 * @param {Object} [options]
 * @param {boolean} [options.monthYearOnly=false] - When true, the date field
 *   renders only the month and year inputs (no day input). Used by
 *   all-claims-v2; the original all-claims flow keeps the full date.
 * @returns {PageSchema}
 */
export const createNewConditionDatePage = ({ monthYearOnly = false } = {}) => ({
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) => createNewConditionName(formData, true),
      undefined,
      false,
    ),
    conditionDate: conditionDateUI({
      title: 'When did your condition start?',
      fullDateHint:
        'You can share an approximate date. If your back pain started in the winter of 2020, enter December 1, 2020.',
      monthYearOnly,
    }),
    'view:forceFieldBlur': forceFieldBlurUI,
  },
  schema: {
    type: 'object',
    properties: {
      conditionDate: conditionDateSchema(monthYearOnly),
      'view:forceFieldBlur': forceFieldBlurSchema,
    },
  },
});

/** @type {PageSchema} full month/day/year variant used by all-claims (v1) */
const newConditionDatePage = createNewConditionDatePage();

export default newConditionDatePage;
